import {customElement} from 'lit/decorators.js';
import {FilterView} from './filter-view';
import {Activity} from './activity';
import {ri} from './runner-idle';
import {IFilterable} from './interfaces/filterable';
import {LitElement} from 'lit';

@customElement('ri-activities')
export class Activities extends FilterView {
  get activities(): Activity[] {
    return this.filterables as Activity[];
  }
  set activities(value) {
    this.filterables = value;
  }
  override get _currentFilterables() {
    return this.filterables
      .filter((filterable: IFilterable) => {
        const activity = filterable as Activity;
        let include = this.intersection;
        for (const filter of this.filters) {
          // Skip any special filters
          if (
            [...this.possibleFilters].find((f) => f.name === filter)?.condition
          )
            continue;
          if (this.intersection) {
            if (!filterable.tags.has(filter)) {
              include = false;
              break;
            }
          } else {
            if (filterable.tags.has(filter)) {
              include = true;
              break;
            }
          }
        }
        for (const filter of this.possibleFilters) {
          if (filter.condition) {
            if (filter.only) {
              if (this.filters.has(filter.name)) {
                include = filter.condition(filterable);
              }
              continue;
            }
            if (
              !this.filters.has(filter.name) &&
              filter.condition(filterable)
            ) {
              include = false;
              break;
            }
          }
        }
        return include;
      })
      .sort(
        this.reverse ? (a, b) => this.compare(b, a) : this.compare
      ) as LitElement[];
  }
  override name = '活动';
  override subtitle =
    '单击或拖动到队列。 Control + 单击以隐藏/显示。';
  override intersection = true;
  override possibleFilters = new Set([
    ...Object.values(ri.resources)
      .filter((resource) => resource.unlocked && !resource.name.includes('Exp'))
      .map((resource) => ({
        name: resource.name,
        displayName: resource.displayName,
      })),
    // {name: 'combat', displayName: 'Combat'},
    {name: 'travel', displayName: 'Travel'},
    {name: 'meditate', displayName: 'Meditation'},
    {name: 'train', displayName: 'Training'},
    ...Object.values(ri.stats)
      .filter((stat) => stat.unlocked)
      .map((stat) => ({
        name: stat.name,
        displayName: stat.displayName,
      })),
    {
      name: 'hiddenByPlayer',
      displayName: 'Hidden',
      condition: (a) => a.hiddenByPlayer,
    },
  ]);
  override filters = new Set([]);
}
